$(function () {
	loaderArticles()
})

function loaderArticles() {
	const $allContent = $('[data-ajax-container]');
	const $allTags = $("[data-blog-tag]");
	
	function removeBorder() {
		const $tradingSection = $('.MainBlog__TrandingWrapper');
		
		if ($tradingSection.length > 0) {
			$tradingSection.prev().css("border-bottom", "unset")
		}
	}
	
	function tugsUpdate(self) {
		const $currentTag = $(self);
		
		$allTags.removeClass('Active');
		$currentTag.addClass('Active');
		
		removeBorder()
		return $currentTag
	}
	
	function getContent(url, func) {
		$.ajax({
			method: 'GET',
			url: url,
			header: {'Content-Type': 'application/json'}
		}).done(func)
	}
	
	$(document).on('click', '[data-show-more]', function() {
		const $blogСontainer = $('[data-blog-container]');
		let $button = $(this);
		let link = $(this).attr('data-next-page');
		
		if (!link.includes('&view=ajax')) {
			link = link + "&view=ajax"
		}

		getContent(`${link}`, function (response) {
			$button.remove()
			$blogСontainer.append($(response).find('.ArticleCard'))
			$blogСontainer.append($(response).find('[data-show-more]'))
		});
	})
	
	$allTags.on('click', function (e) {
		e.preventDefault()
		
		const link = $(this).find('.BlogTags__action').attr('href');
		_self = this
		
		getContent(`${link}/?view=ajax`, function (response) {
			$allContent.html($(response).find("[data-ajax-container]").children())
			
			var newurl = window.location.protocol + '//' + window.location.host + link;
			window.history.replaceState({ path: newurl }, '', newurl);
			window.history.pushState({ path: newurl }, '', newurl);
			
			tugsUpdate(_self)
			AOS.refresh()
		})
	})
	
	removeBorder()
}